import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { Fragment, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { getCookies, contactValidation, postDataToWarehouse } from '../../Utils/FormUtils';

import SuccessMessage from '../Form/SuccessMessage';
import ErrorMessage, { StyledFormErrorMessage } from '../Form/ErrorMessage';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

import { StyledButton } from '../AddToCartBtn/AddToCartBtnStyles';
import { BtnArrow } from '../Icons';

import { ContactMethodRadioGroup, EmailField, PhoneField } from './Fields';

import { StyledFooterFormWrapper, StyledBtnArrowWrapper, StyledFooterFormSuccessSpan } from './FormStyles';

import useIsTouchDevice from '../../hooks/useIsTouchDevice';

var _ref4 = React.createElement(EmailField, { hideLabel: true, required: true });

var _ref5 = React.createElement(PhoneField, { hideLabel: true, required: true });

var _ref6 = React.createElement(LoadingSpinner, null);

var FooterForm = function FooterForm(_ref) {
  var handleFormSubmitDiscountCode = _ref.handleFormSubmitDiscountCode,
      formDiscount = _ref.formDiscount;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSmsSubmission = _useState2[0],
      setIsSmsSubmission = _useState2[1];

  var isTouchDevice = useIsTouchDevice();
  var formRef = useRef(null);
  var successRef = useRef(null);
  var errorRef = useRef(null);

  return ReactDOM.createPortal(React.createElement(
    Fragment,
    null,
    React.createElement(SuccessMessage, {
      ref: successRef,
      formDiscount: formDiscount,
      isSmsSubmission: isSmsSubmission
    }),
    React.createElement(
      'div',
      { ref: formRef },
      React.createElement(
        Formik,
        {
          initialValues: Object.assign({
            contactMethod: isTouchDevice ? 'sms' : 'email',
            email: '',
            phone: ''
          }, getCookies()),
          validate: contactValidation,
          onSubmit: function onSubmit(values, _ref2) {
            var setSubmitting = _ref2.setSubmitting;

            postDataToWarehouse({
              data: values,
              setSubmitting: setSubmitting,
              formRef: formRef.current,
              errorRef: errorRef.current,
              successRef: successRef.current,
              handleFormSubmitDiscountCode: handleFormSubmitDiscountCode,
              hideElementOnSuccess: document.querySelector('.footer-form-btn-arrow'),
              setIsSmsSubmission: setIsSmsSubmission,
              redirectLocation: '',
              isModal: false
            });
          }
        },
        function (_ref3) {
          var isSubmitting = _ref3.isSubmitting,
              isValid = _ref3.isValid,
              values = _ref3.values,
              errors = _ref3.errors,
              touched = _ref3.touched,
              setFieldValue = _ref3.setFieldValue;

          return React.createElement(
            Form,
            null,
            React.createElement(ContactMethodRadioGroup, {
              hideLabel: true,
              align: 'flex-start',
              setFieldValue: setFieldValue,
              isTouchDevice: isTouchDevice
            }),
            React.createElement(
              StyledFooterFormWrapper,
              null,
              values.contactMethod === 'email' ? _ref4 : _ref5,
              React.createElement(
                StyledButton,
                {
                  type: 'submit',
                  useProductPageStyles: true,
                  disabled: isSubmitting,
                  'aria-label': 'Submit Form'
                },
                isSubmitting && _ref6,
                React.createElement(
                  StyledBtnArrowWrapper,
                  {
                    className: 'footer-form-btn-arrow',
                    isSubmitting: isSubmitting,
                    isValid: isValid
                  },
                  React.createElement(BtnArrow, {
                    color: '' + function (props) {
                      return props.theme.dormifyWhite;
                    }
                  })
                ),
                React.createElement(
                  StyledFooterFormSuccessSpan,
                  { ref: successRef },
                  'Success!'
                )
              )
            ),
            React.createElement(ErrorMessage, {
              hide: Object.keys(errors).length > 0 || errorRef.current && errorRef.current.innerText === '',
              ref: errorRef
            })
          );
        }
      )
    )
  ), document.getElementById('dormify-footer__form'));
};

FooterForm.propTypes = {
  handleFormSubmitDiscountCode: PropTypes.func,
  formDiscount: PropTypes.object
};

export default FooterForm;